import React from 'react';
import ServiceTemplate from './ServiceTemplate';

export default function TesisDePregrado() {
  return <ServiceTemplate serviceName="tesis-de-pregrado" />;
}
